import { useState, useEffect, useRef } from 'react';
import { classNames } from '@/shared/lib/classNames/classNames';
import cls from './Menu.module.scss';
import { AppLink, AppLinkTheme } from '@/shared/ui/AppLink';
import Location from '@/shared/assets/icons/location.svg?react';
import arrow from '@/shared/assets/icons/arrow.svg';
import { Button } from '@/shared/ui/Button';

interface MenuProps {
    className?: string;
}

export const Menu = (props: MenuProps) => {
    const { className } = props;
    const [showText1, setShowText1] = useState(false);
    const node = useRef<HTMLDivElement>(null); // Ссылка на элемент, который не должен закрываться при клике

    useEffect(() => {
        // Добавляем обработчик клика в документе
        const handleClickOutside = (event: MouseEvent) => {
            if (node.current && !node.current.contains(event.target as Node)) {
                setShowText1(false); // Закрываем меню, если клик вне элемента
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            // Удаляем обработчик при размонтировании компонента
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className={classNames(cls.Menu, {}, [className])}>
            <ul className={cls.list}>
                <li className={cls.item}>
                    <AppLink className={cls.blockItem} to="https://sberbank-insurance.ru/" theme={AppLinkTheme.PRIMARY}>
                        <span className={cls.link}>Частным клиентам</span>
                    </AppLink>
                </li>
                <li className={cls.item}>
                    <AppLink
                        to="https://sberbank-insurance.ru/policy/ksinsb"
                        className={cls.blockItem}
                        theme={AppLinkTheme.PRIMARY}
                    >
                        <span className={cls.link}>Корпоративным клиентам</span>
                    </AppLink>
                </li>
                <li className={cls.item}>
                    <div className={cls.drop} ref={node}>
                        <button
                            type="button"
                            onClick={() => setShowText1(!showText1)}
                            className={classNames(cls.dropTitle, { [cls.textGreen]: showText1 })}
                        >
                            <p className={cls.link}>Еще</p>
                            <img src={arrow} className={cls.arrow} alt="arrow" />
                        </button>
                        <div className={classNames(cls.text, { [cls.textShown]: showText1 })}>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about">О компании</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/history">История</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/contacts">Контакты</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/news">Новости</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/ESG">ESG</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/info">Раскрытие информации</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/info#financial_metrics">Финансовые показатели</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/info#ins_documentation">
                                        Страховая документация
                                    </a>
                                </span>
                            </div>

                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/info#policy_actions">Общие документы</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/about/procurement">Закупки</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/check-policy">Проверка подписи Страховщика</a>
                                </span>
                            </div>
                            <div className={cls.selectCell}>
                                <span className={cls.selectCellItem}>
                                    <a href="https://sberbank-insurance.ru/reestr_strahovih_agentov">Реестр страховых агентов</a>
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </nav>
    );
};
